function isProtectedApp() {
  var _a;
  const element = document.querySelector('meta[name="backstage-app-mode"]');
  const appMode = (_a = element == null ? void 0 : element.getAttribute("content")) != null ? _a : "public";
  return appMode === "protected";
}

export { isProtectedApp };
//# sourceMappingURL=isProtectedApp.esm.js.map
